import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["fill", "height", "width"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M27.08 23.898L33.4439 17.534C34.3226 16.6553 35.7472 16.6553 36.6259 17.534C37.5046 18.4127 37.5046 19.8373 36.6259 20.716L30.2619 27.08L36.6259 33.4439C37.5046 34.3226 37.5046 35.7472 36.6259 36.6259C35.7472 37.5046 34.3226 37.5046 33.4439 36.6259L27.0799 30.2619L20.716 36.6259C19.8373 37.5046 18.4127 37.5046 17.534 36.6259C16.6553 35.7472 16.6553 34.3226 17.534 33.4439L23.898 27.08L17.534 20.716C16.6553 19.8373 16.6553 18.4127 17.534 17.534C18.4127 16.6553 19.8373 16.6553 20.716 17.534L27.08 23.898Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    viewBox: "0 0 54 54",
    fill: _ctx.color,
    height: _ctx.size,
    width: _ctx.size,
    "aria-hidden": "true"
  }, _hoisted_3, 8, _hoisted_1))
}